import { render, staticRenderFns } from "./CardNotification.vue?vue&type=template&id=d3fbddba&"
import script from "./CardNotification.vue?vue&type=script&lang=js&"
export * from "./CardNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports